import type { RouteRecordRaw } from 'vue-router'

const followMeRoutes: RouteRecordRaw = {
  path: '/follow-me',
  name: 'follow-me',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.follow_me' },
  component: () => import('@/pages/follow-me/FollowMePage.vue'),
}

export default followMeRoutes
